<template>
  <div>
    <slot></slot>
    <v-progress-linear indeterminate color="red" class="mt-2" />
  </div>
</template>

<script>
export default {
  name: "ProgressLinear"
};
</script>